(() => {
  const section = document.querySelector('[data-flash-sale]');
  if (!section) return;

  const endDate = new Date(section.dataset.end);
  if (!Number.isNaN(endDate.getTime())) {
    const timeEl = section.querySelector('[data-flash-sale-time]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      const diff = endDate.getTime() - Date.now();
      if (diff <= 0) {
        section.hidden = true;
        section.style.display = 'none';
        clearInterval(timer);
        return;
      }
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const daysPrefix = days > 0 ? `${days}d ` : '';
      timeEl.textContent = `${daysPrefix}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  const track = section.querySelector('[data-flash-sale-track]');
  const prevBtn = section.querySelector('[data-flash-sale-prev]');
  const nextBtn = section.querySelector('[data-flash-sale-next]');
  if (track && prevBtn && nextBtn) {
    // scrollBy() con behavior:'smooth' se pisa a si mismo si el usuario
    // hace doble clic rapido (el navegador cancela el scroll en curso y
    // vuelve a calcular el delta desde una posicion que todavia se esta
    // moviendo). Se calcula el destino absoluto en base al ancho real de
    // una tarjeta + su gap, y se usa scrollTo() para que cada clic apunte
    // a una posicion fija y predecible en vez de "muevete X mas".
    function cardStep() {
      const card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function scrollByCards(direction) {
      const step = cardStep();
      const visibleCards = Math.max(Math.floor(track.clientWidth / step), 1);
      const maxScroll = track.scrollWidth - track.clientWidth;
      const target = Math.min(Math.max(track.scrollLeft + direction * step * visibleCards, 0), maxScroll);
      track.scrollTo({ left: target, behavior: 'smooth' });
    }
    prevBtn.addEventListener('click', () => scrollByCards(-1));
    nextBtn.addEventListener('click', () => scrollByCards(1));

    // Con pocos productos, en pantallas anchas el riel puede caber
    // completo sin necesidad de scroll -- ahi las flechas no tienen nada
    // que mover y se ocultan para no parecer rotas.
    function updateArrowsVisibility() {
      const hasOverflow = track.scrollWidth > track.clientWidth + 1;
      prevBtn.hidden = !hasOverflow;
      nextBtn.hidden = !hasOverflow;
    }
    updateArrowsVisibility();
    window.addEventListener('resize', updateArrowsVisibility);
  }
})();
